export default "__VITE_ASSET__fi_AKWTi__"